//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCommentRank } from '@/api/shuping'
export default {
  data () {
    return {
      id: this.$route.params.id,
      obj: [],
      length: []
    }
  },
  created () {
    this.geList()
  },
  methods: {
    geList () {
      getCommentRank({
        numberid: this.id
      }).then(data => {
        let totleVoteCnt = 0
        data.obj.forEach((el, index) => {
          if (index < 30) {
            totleVoteCnt = totleVoteCnt + el.num
            this.length.push(parseInt((el.num / data.obj[0].num) * 85) || 0)
            // el.phone = el.phone.substr(0, 3) + '****' + el.phone.substr(7)
            this.obj.push(el)
          }
        })
      })
    }
  }
}
